import { Checkbox, CheckboxProps } from '@makyoapp/makyo-tw-ui'

export type CompCheckboxProps = CheckboxProps

/**
 * CompCheckboxCore
 */
export const CompCheckboxCore = (props: CompCheckboxProps) => {
  return <Checkbox {...props} />
}
